import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = {
  class: "checkbox col-sm-2",
  "data-testid": "checkbox-span"
}
const _hoisted_3 = ["id"]
const _hoisted_4 = ["for"]
const _hoisted_5 = { class: "col-sm-10" }
const _hoisted_6 = { class: "input-group" }
const _hoisted_7 = { class: "input-group-btn" }
const _hoisted_8 = { style: {"padding":"10px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_btn = _resolveComponent("btn")!
  const _component_date_time_picker = _resolveComponent("date-time-picker")!
  const _component_dropdown = _resolveComponent("dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        id: _ctx.uid,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.enabled) = $event)),
        type: "checkbox",
        class: "checkbox"
      }, null, 8, _hoisted_3), [
        [_vModelCheckbox, _ctx.enabled]
      ]),
      _createElementVNode("label", { for: _ctx.uid }, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _cache[3] || (_cache[3] = _createTextVNode("Enabled", -1))
        ], true)
      ], 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.enabled)
        ? (_openBlock(), _createBlock(_component_dropdown, { key: 0 }, {
            dropdown: _withCtx(() => [
              _createElementVNode("li", _hoisted_8, [
                _createVNode(_component_date_time_picker, {
                  modelValue: _ctx.datetime,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.datetime) = $event)),
                  "date-class": "flex-item-1",
                  "time-class": "flex-item-auto",
                  class: "flex-container"
                }, null, 8, ["modelValue"])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_btn, { class: "dropdown-toggle" }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("i", { class: "glyphicon glyphicon-calendar" }, null, -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.datetime) = $event)),
                  type: "text",
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.datetime]
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}